import { gql, useLazyQuery } from '@apollo/client';
import { useState } from 'react';

import { useTrackDragAndDropEditorRUMError } from './useTrackDragAndDropEditorRUMError';

const QUERY_SAVED_ROW_COUNT_ERROR_MESSAGE = 'Unable to fetch saved row count';

export type QuerySavedRowCountResponse = {
  rowCount: { count: number; failure: { __typename: string } | null };
};

const querySavedRowCount = gql`
  query getSavedRowCount {
    rowCount {
      count
      failure {
        __typename
      }
    }
  }
`;

export const useQuerySavedRowCount = () => {
  const [savedRowCount, setSavedRowCount] = useState<number | null>(null);

  const trackError = useTrackDragAndDropEditorRUMError();

  const [fetchSavedRowCount] = useLazyQuery(querySavedRowCount, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (data: QuerySavedRowCountResponse) => {
      if (data?.rowCount?.failure) {
        trackError({ errorMessage: QUERY_SAVED_ROW_COUNT_ERROR_MESSAGE });
      } else {
        const numRows = data?.rowCount?.count;
        setSavedRowCount(numRows);
      }
    },
    onError: (err) => {
      trackError({ error: err, errorMessage: QUERY_SAVED_ROW_COUNT_ERROR_MESSAGE });
    },
  });

  return {
    getSavedRowCount: fetchSavedRowCount,
    savedRowCount,
  };
};
